export default __webpack_public_path__ + "55360b83801018154075c59c8c0d08f7.png";